import { z } from "zod";

/** The custom sender line (the connector tags, admin plans and sender line round, 2026-10-27; brief rule 3 and the review's pins): a project's
 *  own From display name, typed with the signature's placeholders ("{firstname} at {project}"). Pure: the length and the stored line's rule.
 *  The filling is `senderName`'s (`mail.ts`), the chips `SENDER_LINE_PLACEHOLDERS` (`signature.ts`). */

/** the longest stored line, and the longest filled result */
export const SENDER_LINE_MAX = 80;

/** characters a mail header's display name must never carry from a typed line: an address of its own (`@`, `<`, `>`) or a line break or
 *  control character that would end the header */
const UNSAFE = /[@<>\u0000-\u001f\u007f]/;
export const SENDER_LINE_UNSAFE_MESSAGE = "A sender line has no @, < or > and no line break";

/** the stored line: at most 80 characters, nothing that could pose as an address or break the header; empty means the team form */
export const SenderLineSchema = z.string().trim().max(SENDER_LINE_MAX).refine((s) => !UNSAFE.test(s), { message: SENDER_LINE_UNSAFE_MESSAGE });
